module.exports = __webpack_public_path__ + "img/eduac-courses-home.afa4e7c6.jpg";